const sectionCode = "SPRO2";
const chartCode = "C021x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T21Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T21Procedures };
